
export default {
  name: 'BuildInfo',
  props: {
    showBuildInfo: {
      type: Boolean,
      default: true
    },
    showLastChecked: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    buildLabel() {
      return 'Build Date';
    },
    formattedBuildDate() {
      return this.$buildInfo ? this.$buildInfo.formattedDate : 'Unknown';
    },
    lastCheckedTime() {
      if (!this.$buildInfo || !this.$buildInfo.lastChecked) return '';
      
      const date = new Date(this.$buildInfo.lastChecked);
      return date.toLocaleTimeString();
    }
  },
  mounted() {
    // Force component to re-render when build info changes
    if (this.$buildInfo) {
      this.$watch(
        () => this.$buildInfo.timestamp,
        () => this.$forceUpdate()
      );
    }
  }
}
